import Account from "@/API/Account.js"
import LoadingMixin from "@/mixins/loading"
import SystemMixin from "@/mixins/system"

import { options as documentTypes } from "@/enums/document_type"

import ValidationMixin from "@/mixins/validation.js"
import { email, minLength, required, sameAs } from "@vuelidate/validators"

import {get, sync} from "vuex-pathify"

export default {
    mixins: [LoadingMixin, SystemMixin, ValidationMixin],
    computed: {
        ... sync('Account', ['form']),
        documentTypes(){
            return documentTypes.map(item => {
                item.label = this.$t(item.label)
                return item
            })
        }
    },
    validations(){
        let form = {
            name: { required },
            // document_type: { required },
            // document: { required },
            // phone: { required },
            // email: { required, email },
        }
        return { form }
    },
    methods: {
		/**
		 * Action validate
		 * @returns {Promise<boolean>}
		 */
		async validate() {
            this.v$.$touch()

            console.debug('Account/Form.GeneralForm@validate: Validating data.')

            return !this.v$.$invalid
        },
        /**
         * Save form
         * @returns {Promise<boolean>}
         */
        async save() {
            if (!await this.validate()) return false

            const data = copy_obj(this.form)

            console.debug('Account/FormPage@save: Savinf data.', {data})

            const formData = object_to_formdata(this.form)

            this.loading()

            const [err, res] = await Account.update(this.form.id, formData)

            this.loaded()

            if (err) {
                console.error('Account/FormPage@save: Error saving data.', err)
                return this.$alertError(this.handleRequestError(err))
            }

            this.form = res.data.data

            console.debug('Account/FormPage@save: Data saved.')

            return true
        },
    }
}
